import { browserPlatform } from './browser.ts'
import type { Platform } from './types.ts'

/** 구현체 선택은 이 한 줄뿐이다. 데스크톱 셸이 붙으면 여기서 분기한다. */
export const platform: Platform = browserPlatform

export type * from './types.ts'
